<template>
  <div>
    <a-modal :visible="modalVisible" :closable="false" :width="800" @cancel="closeModal">
      <a-table :width="2000" :columns="columns" :data-source="taskInfoList">
        <span slot="taskName" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.taskName">
            <a class="custom-link" :href="link(record)" target="_blank">{{ record.taskName }}</a>
          </a-tooltip>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="taskStatus[record.status]" :color="taskStatus[record.status].color">{{ taskStatus[record.status].label }}</a-tag>
        </span>
        <span slot="is_over_time" slot-scope="text, record">
          <a-tag v-if="record.is_over_time == 1" color="red">{{ '是' }}</a-tag>
          <a-tag v-if="record.is_over_time == 0" color="green">{{ '否' }}</a-tag>
        </span>
      </a-table>
      <div slot="footer" />
    </a-modal>
  </div>
</template>

<script>
import { taskStatus } from '@/utils/dictionary';
import { queryTasks } from '@/api/data/task';
export default {
  props: {
    taskList: {
      type: Array,
      default: null
    }
  },

  data() {
    return {
      modalVisible: false,
      taskInfoList: [],
      taskStatus,
      columns: [
        {
          title: 'ID',
          dataIndex: 'taskId',
          width: '10%',
          key: 'taskId',
          scopedSlots: { customRender: 'customKey' }
        },
        {
          title: '标题',
          dataIndex: 'taskName',
          width: '40%',
          key: 'taskName',
          scopedSlots: { customRender: 'taskName' }
        },
        {
          title: '开发完成时间',
          dataIndex: 'dev_end_time',
          width: '15%',
          key: 'dev_end_time',
          scopedSlots: { customRender: 'dev_end_time' }
        },
        {
          title: '提审时间',
          dataIndex: 'to_qa_time',
          width: '15%',
          key: 'to_qa_time',
          scopedSlots: { customRender: 'to_qa_time' }
        },
        {
          title: '是否超时提审',
          dataIndex: 'is_over_time',
          width: '15%',
          key: 'is_over_time',
          scopedSlots: { customRender: 'is_over_time' }
        }
      ]
    };
  },
  computed: {
    link() {
      return record => {
        return record && record.project && record.taskId ? this.$router.resolve({ name: 'page:project:task:detail', query: { taskId: record.taskId }, params: { project_id: record.project }}).href : '';
      };
    }
  },
  mounted() {
    this.getTaskList();
  },
  methods: {
    // 获取任务列表
    getTodoList() {
      this.modalVisible = true;
    },
    getTaskList() {
      this.loading = true;
      queryTasks({ ids: this.taskList }).then(res => {
        this.taskInfoList = res.data;
      });
    },
    closeModal() {
      this.modalVisible = false;
    },
    open() {
      this.modalVisible = true;
    }
  }
};
</script>

<style scoped>
.purple {
  background-color: rgba(128, 50, 150, 0.5);
  color: white;
  border-radius: 6px;
}

.orange {
  background-color: orange;
  color: white;
  border-radius: 6px;
}

.purple-orange {
  background: linear-gradient(to right, rgba(128, 50, 150, 0.5) 50%, orange 50%);
  color: white;
  border-radius: 6px;
}
</style>
